/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IGetRegionCitiesResponseSchema } from '../../entities/schemas/GetRegionCitiesResponseSchema';

export type TGetRegionCitiesModel = IModel<IGetRegionCitiesRequest, TGetRegionCitiesResponse>;

export interface IGetRegionCitiesRequest {
  /** ID региона **/
  regionId?: number | null;
}

export type TGetRegionCitiesResponse = IGetRegionCitiesResponse200 | IGetRegionCitiesResponse400;

export interface IGetRegionCitiesResponse200 extends IModelResponse<IGetRegionCitiesResponse> {
  statusCode: 200;
}

export interface IGetRegionCitiesResponse400 extends IModelResponse<IGetRegionCitiesResponseError> {
  statusCode: 400;
}

export interface IGetRegionCitiesResponse {
  data: IGetRegionCitiesResponseSchema;
  status: EStatus;
}

export interface IGetRegionCitiesResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetRegionCitiesResponse | IGetRegionCitiesResponseError;

export enum EStatus {
  /** undefined **/
  Ok = 'ok',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetRegionCitiesResponse): TResponse200;
  400(response: IGetRegionCitiesResponseError): TResponse400;
}
